import { render, staticRenderFns } from "./OrdersMaps.vue?vue&type=template&id=0ba152db"
import script from "./OrdersMaps.vue?vue&type=script&lang=js"
export * from "./OrdersMaps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports